export default class CloudProjectService {
  /** @type {null|number} */
  _id = null
  /** @type {null|number} */
  _idServiceTerminationPoint = null
  /** @type {null|number} */
  _maxUnits = null
  /** @type {null|number} */
  _minUnits = null
  /** @type {null|string} */
  _name = null
  /** @type {null|number} */
  _quantity = null
  /** @type {null|string} */
  _unitType = null
  /** @type {null|number} */
  _unitsPerStep = null
  /** @type {null|number} */
  _used = null

  loadFromObject (item) {
    for (const prop in item) {
      if (this[prop] !== undefined || this['_' + prop] !== undefined) {
        this[prop] = item[prop]
      }
    }
  }

  get id () {
    return this._id
  }

  set id (value) {
    this._id = value
  }

  get idServiceTerminationPoint () {
    return this._idServiceTerminationPoint
  }

  set idServiceTerminationPoint (value) {
    this._idServiceTerminationPoint = value
  }

  get maxUnits () {
    return this._maxUnits
  }

  set maxUnits (value) {
    this._maxUnits = value
  }

  get minUnits () {
    return this._minUnits
  }

  set minUnits (value) {
    this._minUnits = value
  }

  get name () {
    return this._name
  }

  set name (value) {
    this._name = value
  }

  get quantity () {
    return this._quantity
  }

  set quantity (value) {
    this._quantity = value
  }

  get unitType () {
    return this._unitType
  }

  set unitType (value) {
    this._unitType = value
  }

  get unitsPerStep () {
    return this._unitsPerStep
  }

  set unitsPerStep (value) {
    this._unitsPerStep = value
  }

  get used () {
    return this._used
  }

  set used (value) {
    this._used = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Cloud/Response/CloudProjectService.js